import React from "react";

function TablaEstadoNacimiento() {
  return (
    <div className="tablaGrafica">
            <table>
      <thead>
        <tr>
          <th>Edo. Nac.</th>
          <th>Total Curps Únicos</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Aguas Calientes</td>
          <td>127</td>
        </tr>
        <tr>
          <td>Baja California</td>
          <td>31442</td>
        </tr>
        <tr>
          <td>Baja California Sur</td>
          <td>2353</td>
        </tr>
        <tr>
          <td>Campeche</td>
          <td>10107</td>
        </tr>
        <tr>
          <td>Chiapas</td>
          <td>4576</td>
        </tr>
        <tr>
          <td>Chihuahua</td>
          <td>3853</td>
        </tr>
        {/* Agrega más filas si es necesario */}
      </tbody>
    </table>
    </div>
  );
}

export default TablaEstadoNacimiento;
